@if (favoritesIsLoading()) {
  <div class="relative min-h-[5rem] w-full">
    <korviu-loader />
  </div>
} @else {
  @if (favoritesHasError()) {
    <div
      class="flex min-h-[8rem] flex-col items-center justify-center gap-4"
      role="alert"
      data-testid="favorites-error"
    >
      <span class="text-[1.125rem] text-[#505760]">{{ 'rewards.error' | translate }}</span>
      <korviu-button color="tertiary" (onclick)="onRetryFavoritesClick()">
        {{ 'common.tryAgain' | translate }}
      </korviu-button>
    </div>
  } @else if (favorites().length) {
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-6">
      @for (favorite of favorites(); track favorite.id) {
        <app-product-card
          [isFavorite]="favorite.is_favorite"
          [name]="isEnglish() ? favorite.name : favorite.name_es"
          [category]="isEnglish() ? favorite.categories[0]?.name : favorite.categories[0]?.name_es"
          [price]="+favorite.price"
          [image]="favorite.image"
          [productId]="favorite.id"
        />
      }
    </div>
  } @else {
    <div
      class="flex relative flex-col items-center rounded-lg border md:border-none border-solid border-[#EEEEEF] border-t-lg p-4 md:p-0 mb-8 w-full"
    >
      <div
        class="rounded-lg favorites px-4 py-2 h-[3.45rem] flex gap-2 items-center absolute top-6 left-8 md:top-4 md:left-4"
      >
        <span class="text-[1.75rem] md:text-[1.9375rem] text-[#003555] font-bold">0</span>
        <span class="text-[1.1875rem] md:text-[1.375rem] text-[#0072B9]">{{ 'rewards.favorites' | translate }}</span>
      </div>
      <div class="w-full md:bg-[#E6F2F1] rounded-t-lg flex justify-center" data-testid="empty-favorites-visual">
        <img
          src="../../../../../assets/img/rewards/empty-favorites.svg"
          alt="forest"
          class="max-w-[30rem] max-auto size-full md:flex hidden"
        />
        <img
          src="../../../../../assets/img/rewards/no-favorites-mobile.svg"
          alt="forest"
          class="max-w-[30rem] max-auto size-full flex md:hidden"
        />
      </div>
      <div
        class="flex flex-col items-center md:flex-row md:justify-between gap-4 rounded-b-lg w-full md:border border-none border-solid border-[#EEEEEF] md:px-6 md:py-4"
      >
        <div class="flex flex-col gap-2">
          <span class="text-[#222528] text-[1rem] md:text-[1.375rem] font-bold">{{
            'rewards.noFavoritesYet' | translate
          }}</span>
          <span class="text-[#505760] text-[1rem] md:text-[1.125rem]">{{
            'rewards.markRewardsWithHeart' | translate
          }}</span>
        </div>
        <div class="w-full md:w-auto h-min">
          <korviu-button color="tertiary" (onclick)="onExploreClick()">
            <div class="flex flex-row gap-2">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12.0006 2C17.5243 2 22.0021 6.47784 22.0021 12.0016C22.0021 17.5253 17.5243 22.003 12.0006 22.003C6.47686 22.003 1.99902 17.5253 1.99902 12.0016C1.99902 6.47784 6.47686 2 12.0006 2ZM14.9395 16.5013H9.06166C9.7137 18.9155 10.8471 20.503 12.0006 20.503C13.1541 20.503 14.2874 18.9155 14.9395 16.5013ZM7.50888 16.5019L4.78639 16.5017C5.74473 18.0347 7.17818 19.2403 8.88056 19.9123C8.35828 19.0926 7.92729 18.0662 7.61029 16.8968L7.50888 16.5019ZM19.2148 16.5017L16.4923 16.5019C16.1685 17.8357 15.7009 19.0014 15.1195 19.9123C16.7165 19.2824 18.0762 18.1834 19.0296 16.7853L19.2148 16.5017ZM7.09399 10.0009H3.73638L3.73163 10.0182C3.57954 10.6545 3.49902 11.3186 3.49902 12.0016C3.49902 13.0578 3.6916 14.0689 4.04358 15.0019L7.21674 15.0015C7.07444 14.0524 6.99902 13.0442 6.99902 12.0016C6.99902 11.3176 7.03148 10.6483 7.09399 10.0009ZM15.3975 10.001H8.60364C8.53562 10.6413 8.49901 11.311 8.49901 12.0016C8.49901 13.0611 8.58516 14.0714 8.73875 15.0016H15.2624C15.416 14.0714 15.5021 13.0611 15.5021 12.0016C15.5021 11.311 15.4655 10.6413 15.3975 10.001ZM20.2652 10.0001L16.9072 10.0009C16.9697 10.6484 17.0021 11.3176 17.0021 12.0016C17.0021 13.0442 16.9267 14.0524 16.7844 15.0015L19.9576 15.0019C20.3095 14.0689 20.5021 13.0578 20.5021 12.0016C20.5021 11.3122 20.4201 10.6419 20.2652 10.0001ZM8.88162 4.0907L8.85871 4.09942C6.8114 4.91413 5.15538 6.50144 4.25071 8.5013L7.29883 8.50167C7.61219 6.74888 8.15903 5.22295 8.88162 4.0907ZM12.0006 3.5L11.8849 3.5053C10.6195 3.62105 9.39699 5.62302 8.82928 8.50125H15.1719C14.6057 5.63109 13.3885 3.63228 12.1269 3.50631L12.0006 3.5ZM15.1206 4.09076L15.2274 4.26485C15.8966 5.37732 16.4048 6.8372 16.7023 8.50167L19.7504 8.5013C18.8858 6.5899 17.3348 5.05536 15.4118 4.21203L15.1206 4.09076Z"
                    fill="#FCFCFC"
                  />
                </svg>
              </i>
              <span class="text-[1rem] text-[#FCFCFC]">{{ 'rewards.exploreRewardsButton' | translate }}</span>
            </div>
          </korviu-button>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="flex items-center justify-between">
        <span class="text-[#222528] text-[1.1875rem] font-bold">{{ 'rewards.suggested' | translate }}</span>
      </div>
      @if (suggestedIsLoading()) {
        <div class="relative min-h-[5rem] w-full" data-testid="suggested-loading">
          <korviu-loader />
        </div>
      } @else if (suggestedHasError()) {
        <div
          class="flex min-h-[5rem] flex-col items-center justify-center gap-4"
          role="alert"
          data-testid="suggested-error"
        >
          <span class="text-[1.125rem] text-[#505760]">{{ 'rewards.error' | translate }}</span>
          <korviu-button color="tertiary" (onclick)="onRetrySuggestedClick()">
            {{ 'common.tryAgain' | translate }}
          </korviu-button>
        </div>
      } @else if (suggested().length) {
        <div class="grid grid-cols-2 gap-4 md:grid-cols-4" data-testid="suggested-products">
          @for (product of suggested(); track product.id) {
            <app-product-card
              [isFavorite]="product.is_favorite"
              [name]="isEnglish() ? product.name : product.name_es"
              [category]="isEnglish() ? product.categories[0]?.name : product.categories[0]?.name_es"
              [price]="+product.price"
              [image]="product.image"
              [productId]="product.id"
              [label]="product.label?.toLowerCase()"
            />
          }
        </div>
      } @else {
        <div class="mx-auto min-h-[3rem] text-[1.125rem] text-[#505760]" role="status" data-testid="suggested-empty">
          {{ 'rewards.noProductsFound' | translate }}
        </div>
      }
    </div>
  }
}
